import {
  FilterCategoryModel,
  FilterItemModel,
} from "@/models/filterItem.model";
import { KioskModel } from "@/models/kiosk.model";
import Cafe from "@/assets/project-assets/Left-side-menu/Cafés.svg";
import ATM from "@/assets/project-assets/Left-side-menu/ATM.svg";
import CustomerServiceDesk from "@/assets/project-assets/Left-side-menu/Info.svg";
import BooksStationery from "@/assets/project-assets/Left-side-menu/Books-Stationery.svg";
import Bus from "@/assets/project-assets/Left-side-menu/Bus.svg";
import Desserts from "@/assets/project-assets/Left-side-menu/Confectionary.svg";
import Entrance from "@/assets/project-assets/Left-side-menu/Entrance.svg";
import FastFood from "@/assets/project-assets/Left-side-menu/Fast-food.svg";
import GiftCard from "@/assets/project-assets/Left-side-menu/Gift-cards.svg";
import HomeTech from "@/assets/project-assets/Left-side-menu/Home-Tech.svg";
import Hypermarket from "@/assets/project-assets/Left-side-menu/Hypermarkets.svg";
import JewelleryWatches from "@/assets/project-assets/Left-side-menu/Jewellery-Watches.svg";
import Kids from "@/assets/project-assets/Left-side-menu/Kids-Maternity.svg";
import LostFound from "@/assets/project-assets/Left-side-menu/Box.svg";
import MallManager from "@/assets/project-assets/Left-side-menu/Manager.svg";
import OpticsEyewear from "@/assets/project-assets/Left-side-menu/Optics-Eyewear.svg";
import Parking from "@/assets/project-assets/Left-side-menu/Parking.svg";
import PrayerRoomMale from "@/assets/project-assets/Left-side-menu/Prayer-room-male.svg";
import PrayerRoomFemale from "@/assets/project-assets/Left-side-menu/Prayer-room-female.svg";
import Restaurant from "@/assets/project-assets/Left-side-menu/Restaurant.svg";
import RestroomFemale from "@/assets/project-assets/Left-side-menu/Female.svg";
import RestroomMale from "@/assets/project-assets/Left-side-menu/Men.svg";
import SpecialtyShop from "@/assets/project-assets/Left-side-menu/Specialty-shop.svg";
import SportsLeisure from "@/assets/project-assets/Left-side-menu/Sports-Leisure.svg";
import Taxi from "@/assets/project-assets/Left-side-menu/Taxi.svg";
import UberCareem from "@/assets/project-assets/Left-side-menu/Uber.svg";
import Wifi from "@/assets/wifi.svg";
import Share from "@/assets/project-assets/Left-side-menu/Coin.svg";
import Wheelchair from "@/assets/project-assets/Left-side-menu/Wheelchair.svg";
import BabyChangingFemale from "@/assets/project-assets/Left-side-menu/Female-Baby-Changing.svg";
import BabyChangingMale from "@/assets/project-assets/Left-side-menu/Male-baby-changing.svg";
import FirstAid from "@/assets/project-assets/Left-side-menu/First-aid.svg";
import AccessibleParking from "@/assets/accessible-parking.svg";
import FemaleAccessibleToilet from "@/assets/accessible-toilet-F.svg";
import MaleAccessibleToilet from "@/assets/accessible-toilet-M.svg";
import Hotel from "@/assets/project-assets/Left-side-menu/hotel-solid.svg";
import HotelWhite from "@/assets/project-assets/Left-side-menu/hotel-solid-white.svg";
import Facilities from "@/assets/facilities-ultra.svg";
import FacilitiesWhite from "@/assets/facilities-ultra-white.svg";
import { FaBagShopping, FaFaceSmile, FaUtensils } from "react-icons/fa6";
import { AmenityModel } from "proximiio-js-library/lib/models/amenity";
import Feature from "proximiio-js-library/lib/models/feature";
import Entertainment from "@/assets/entertainment-light.svg";
import iFly from "@/assets/ifly-light.svg";
import LittleExplorers from "@/assets/little-explorers-light.svg";
import MagicPlanet from "@/assets/magic-planet-light.svg";
import Snow from "@/assets/snow-light.svg";
import VoxCinema from "@/assets/vox-cinema-light.svg";

import BikeParking from "@/assets/project-assets/bike-parking.svg";
import PhoneCharging from "@/assets/phone-charging-light.svg";
import Banks from "@/assets/bank-light.svg";
import DepartmentStores from "@/assets/departement-store-light.svg";
import Electronics from "@/assets/electronics-light.svg";
import FashionAccessories from "@/assets/fashion-accessories-light.svg";
import FashionLadies from "@/assets/fashon-ladies-light.svg";
import FashionMen from "@/assets/fashion-men-light.svg";
import FashionUnisex from "@/assets/fashion-unisex-light.svg";
import Swimwear from "@/assets/swimwear-light.svg";
import LeatherProducts from "@/assets/leather-products-light.svg";
import Pharmacy from "@/assets/health-beauty-light.svg";
import Tailors from "@/assets/tailors-light.svg";
import HealthyDining from "@/assets/healthy-dining-light.svg";
import CarBattery from "@/assets/car-battery-light.svg";
import ElectricWheelchairs from "@/assets/electric-wheelchairs-light.svg";
import FamilyRoom from "@/assets/family-room-light.svg";
import CivilRegistration from "@/assets/civil-registration-light.svg";

export const getListAsClosest = () => {
  const closestList = [];
  for (const category of filterCategories) {
    closestList.push(category.items.filter((item) => item.listAsClosest));
  }
  return closestList.flat(2);
};

export const getHiddenItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter((item) => item.hideMapIcon)) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getExcludedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.excludeFromSearch,
    )) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getHiddenUntilSelectedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.hideIconUntilSelected,
    )) {
      list.push(item.id);
    }
  }
  return list.flat();
};

export const filterCategories: FilterCategoryModel[] = [
  {
    title: "shop",
    id: "shop",
    color: "343,68%,28%",
    icon: FaBagShopping,
    items: [
      {
        title: "banks-financial",
        iconImage: Banks,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:8a57a458-97e5-4315-8e67-c817eccbe4f4",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "books-stationery-toys-games-gifts",
        iconImage: BooksStationery,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:0fbc1bbf-04d5-4bc1-845c-400037b86b5e",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "department-stores",
        iconImage: DepartmentStores,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:cbee6631-439b-4214-89af-6102a53320c3",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "electronics-home-mobile",
        iconImage: Electronics,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:636463d8-613e-4eb7-a531-f7f596e63215",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-accessories",
        iconImage: FashionAccessories,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:974d73ae-860a-4abf-97b7-4cf29148b480",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-child",
        iconImage: Kids,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:6249b4b1-8568-4da1-943b-286ad32be718",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-ladies",
        iconImage: FashionLadies,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:17248af5-c0ab-4a0c-b38a-cfaa0b8fce61",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-men",
        iconImage: FashionMen,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:4e480023-056b-4eb9-84c6-2a23787f99ac",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-unisex",
        iconImage: FashionUnisex,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:e7e755de-381d-491f-a5f8-cf43ac7b8434",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "household-furtniture-carpet",
        iconImage: HomeTech,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:77993125-46fb-48c3-ae61-f9f800e0db09",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "hypermarket",
        iconImage: Hypermarket,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:84cdc412-131a-4c94-b128-5bf63e7bf654",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "jewellery-watches",
        iconImage: JewelleryWatches,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:5d022d24-b3ce-42a8-bf66-06790ddaf3f4",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "lingerie-swimwear",
        iconImage: Swimwear,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:a06aceec-9cd8-4239-b36e-592b008e176d",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "luggage-leather",
        iconImage: LeatherProducts,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:dbeedac1-3032-435a-bfad-f799b34b6643",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "optics-sunglasses",
        iconImage: OpticsEyewear,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:27b166e6-cce3-4046-8e93-8009711dbed1",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "pharmacy-health-fitness-cosmetics-perfumes",
        iconImage: Pharmacy,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:0b37a151-bb01-4cee-bffe-fee9a4908357",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "speciality-stores",
        iconImage: SpecialtyShop,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:da347480-98de-49f5-8da0-99e15bb1034d",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "sportswear-goods",
        iconImage: SportsLeisure,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:215977ae-ccd7-499b-89c7-6f9552dc3f33",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "tailors-textiles",
        iconImage: Tailors,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:e4504805-d7fa-4c9f-b9c2-01f790a0c023",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "dine",
    id: "dine",
    color: "183,68%,21%",
    icon: FaUtensils,
    items: [
      {
        title: "chocolates-confectionery-icecream",
        iconImage: Desserts,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:9d81c0bb-15fa-43ee-9ea9-6b5dd664c64d",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "cafes",
        iconImage: Cafe,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:8d977090-fa3a-43b5-9937-4ef3d67d1067",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fast-food",
        iconImage: FastFood,
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:95ebb5b9-fbde-4740-b519-da32ea8e9f81",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "restaurants",
        iconImage: Restaurant,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:8714c125-262c-4e04-a20b-e8861c99719f",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "healthy-dining",
        iconImage: HealthyDining,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:369b52da-5546-40ff-abfe-82f9b39bb5a9",
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "leisure",
    id: "leisure",
    color: "207,19%,53%",
    icon: FaFaceSmile,
    items: [],
  },
  {
    title: "unwind-stay",
    id: "unwind-stay",
    color: "45,28%,47%",
    iconImage: Hotel,
    iconImageAlt: HotelWhite,
    listed: false,
    items: [
      {
        title: "kempinski",
        iconImage: Hotel,
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:12f77321-5d4a-4ef3-8ac7-3d7366ce1453",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "facilities",
    id: "facilities",
    color: "218,48%,22%",
    iconImage: Facilities,
    iconImageAlt: FacilitiesWhite,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:44478839-afb0-4eb3-b781-37dfb46f7a38",
        type: "list",
      },
      {
        title: "male-prayer-room",
        iconImage: PrayerRoomMale,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:94bf8e55-1c75-4f8e-963c-279951117edd",
        type: "list",
      },
      {
        title: "female-toilet",
        iconImage: RestroomFemale,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:023b477b-d312-4736-836c-808686f702c4",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
      },
      {
        title: "male-toilet",
        iconImage: RestroomMale,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:5e356489-a8b7-466e-8ee8-0e14ca1120a9",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
      },
      {
        title: "atm",
        iconImage: ATM,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:6dbc7e6e-905b-422e-908f-15390abc3022",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "customer-service-desk",
        iconImage: CustomerServiceDesk,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:dbdbab8c-a407-48ad-8580-f61230447834",
        type: "closest",
      },
      {
        title: "family-room",
        iconImage: FamilyRoom,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:3042e540-4fc6-4d11-97b5-9d7284e811f6",
        type: "closest",
        excludeFromSearch: true,
      },
      {
        title: "baby-changing-room-female",
        iconImage: BabyChangingFemale,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:023b477b-d312-4736-836c-808686f702c4",
        type: "closest",
        excludeFromSearch: true,
      },
      {
        title: "baby-changing-room-male",
        iconImage: BabyChangingMale,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:5e356489-a8b7-466e-8ee8-0e14ca1120a9",
        type: "closest",
        excludeFromSearch: true,
      },
      {
        title: "female-accessible-toilet",
        iconImage: FemaleAccessibleToilet,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:023b477b-d312-4736-836c-808686f702c4",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
      },
      {
        title: "male-accessible-toilet",
        iconImage: MaleAccessibleToilet,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:5e356489-a8b7-466e-8ee8-0e14ca1120a9",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
      },
      {
        title: "taxi-pickup",
        iconImage: Taxi,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:bbe59b01-54d9-4bfa-bc9e-5bcf1a80f5ad",
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "uber-careem",
        iconImage: UberCareem,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:9c8cbdbf-7b6a-4119-871f-90ce08cb9c53",
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "bus-stop",
        iconImage: Bus,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:f53a1463-8d3e-414b-868f-c9ae83dfd8ac",
        type: "list",
      },
      {
        title: "entrance",
        iconImage: Entrance,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:2044f08f-99ce-4a07-811c-5958835a77d0",
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "pod-parking",
        iconImage: AccessibleParking,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:fba02219-1882-43c9-915f-267a0ca0bfee",
        type: "list",
        excludeFromSearch: true,
      },
      {
        title: "bike-parking",
        iconImage: BikeParking,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:6375d7ed-9d4b-4e2d-b4d0-4fbbbd63e274",
        type: "list",
      },
      {
        title: "car-battery-starter",
        iconImage: CarBattery,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:dbdbab8c-a407-48ad-8580-f61230447834",
        type: "list",
      },
      {
        title: "lost-found",
        iconImage: LostFound,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:dbdbab8c-a407-48ad-8580-f61230447834",
        type: "closest",
      },
      {
        title: "first-aid-room",
        iconImage: FirstAid,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:dbdbab8c-a407-48ad-8580-f61230447834",
        type: "closest",
      },
      {
        title: "phone-charging",
        iconImage: PhoneCharging,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:dbdbab8c-a407-48ad-8580-f61230447834",
        type: "closest",
      },
      {
        title: "wheelchairs",
        iconImage: Wheelchair,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:c4d1c6af-892e-4594-b390-722f1cbd7f45",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
      },
      {
        title: "electric-wheelchairs",
        iconImage: ElectricWheelchairs,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:dbdbab8c-a407-48ad-8580-f61230447834",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
      },
      {
        title: "gift-card",
        iconImage: GiftCard,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:dbdbab8c-a407-48ad-8580-f61230447834",
        type: "closest",
      },
      {
        title: "mall-management-office",
        iconImage: MallManager,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:a7b31f2a-779b-4ed8-8c0d-ccc4490a1e5b",
        type: "closest",
        hideIconUntilSelected: true,
      },
      {
        title: "civil-registry",
        iconImage: CivilRegistration,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:69895c53-fae3-47d0-8c8f-b751c9bc176e",
        type: "closest",
        hideIconUntilSelected: true,
      },
      {
        title: "parking-bays",
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:1a7e779f-99e9-46e4-b57d-7d9273d29258",
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:c99b62a4-ec8c-42c8-beac-f54e2224641e",
        ],
        type: "list",
        listed: false,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "vacant",
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:ef3a18a0-a35a-4e9d-8bcc-e23069f3f0cc",
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: true,
      },
      {
        title: "others",
        id: [
          "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:e3651181-42cb-42ce-b48e-9df55948883c",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: true,
      },
      {
        title: "parking",
        iconImage: Parking,
        id: "472cf69c-ec45-4f36-bc78-eb87ef69d5f7:3f861a78-dd83-4ac7-a24f-532fb7a93b74",
        type: "list",
        listed: false,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "notlistedbuttobehide",
        id: [],
        type: "list",
        listed: false,
      },
      {
        title: "wifi",
        iconImage: Wifi,
        type: "info",
        listed: false,
        content: {
          en: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">We Understand that staying connected is important in today’s world. That’s why we’re excited to offer #Free_ Mall_WiFi to all our shoppers.</p>
						<ul class="mb-4">
							<li>1. Please choose #Free_Mall_WiFi from the list of Wi-Fi networks.</li>
							<li>2. Your device should automatically be taken to our login page.</li>
							<li>3. Enter your details and follow the instructions to gain high-speed internet service.</li>
						</ul>
					`,
          ar: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">نحن نتفهم أن البقاء على اتصال أمر مهم في عالم اليوم.لهذا السبب نحن متحمسون لتقديم خدمة فري وايفاي لجميع المتسوقين لدينا</p>
						<ul>
							<li>من قائمة الشبكات #Free_Mall_WiFi الرجاء اختيار</li>
							<li>يجب أن يتم نقل جهازك تلقائيا إلى صفحة تسجيل الدخول الخاصة بنا</li>
							<li>أدخل بياناتك واتبع التعليمات للحصول على خدمة إنترنت عالي السرعة</li>
						</ul>
					`,
        },
      },
      {
        title: "share",
        iconImage: Share,
        type: "info",
        listed: false,
        content: {
          en: `
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">Join SHARE</a>
						<h3 class="text-2xl font-bold mb-6">Get More At Mall of the Emirates</h3>
						<p class="mb-6">As a member of the SHARE rewards programme, you get cash back in points at all stores and restaurants in Mall of the Emirates and beyond. Join the SHARE programme now – it’s free and will only take you a few minutes.</p>
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">Join SHARE Rewards</a>
					`,
          ar: `
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">سجلوا في تطبيق شير</a>
					<h3 class="text-2xl font-bold mb-6">احصلوا على المزيد في مول الإمارات<h3>
					<p class="mb-6">تخولكم عضويتكم في برنامج المكافآت شير استرداد بعض النقود في صورة نقاط لدى جميع المتاجر والمطاعم في مول الإمارات وأماكن أخرى خارج المول. انضموا إلى برنامج المكافآت شير الآن - فهو مجاني ولا يلزم لانضمامكم إليه سوى دقائق معدودة.</p>
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">سجلوا في تطبيق شير</a>
					`,
        },
      },
    ],
  },
];

filterCategories.push({
  title: "hidden",
  id: "hidden",
  listed: false,
  items: [
    {
      title: "hidden",
      id: getHiddenUntilSelectedItems() as string[],
      type: "list",
      listed: false,
    },
  ],
});

export const kiosks: KioskModel[] = [
  {
    name: "kiosk",
    latitude: 25.21620020891565,
    longitude: 55.40792571152656,
    level: 0,
    pitch: 40,
    bearing: 10,
    zoom: 18,
    poiId:
      "75698d35-0918-4a2b-a8ab-77b93a618e61:c2f3d327-d2ee-4d6f-a14f-2a85dfb1ab8d",
  },
];

export const excludedAmenities: string[] = getExcludedItems() as string[];

// Function to build additional filters based on amenities and features
export const buildAdditionalFilters = ({
  amenities,
  features,
  language,
}: {
  amenities: AmenityModel[] | null;
  features: Feature[] | null;
  language: string;
}): FilterItemModel[] | void => {
  // Early exit if amenities or features are missing
  if (!amenities) {
    console.error("amenities is null");
    return;
  }

  if (!features) {
    console.error("features is null");
    return;
  }

  // Define amenity titles and their mapping to ids/features
  const amenityMapping: {
    [key: string]: {
      amenity?: AmenityModel;
      features: Feature[];
      icon: string;
    };
  } = {
    "Snow/Ski": { amenity: undefined, features: [], icon: Snow },
    "Vox Cinema": { amenity: undefined, features: [], icon: VoxCinema },
    "Magic Planet": { amenity: undefined, features: [], icon: MagicPlanet },
    iFLY: { amenity: undefined, features: [], icon: iFly },
    "Little Explorers": {
      amenity: undefined,
      features: [],
      icon: LittleExplorers,
    },
    Entertainment: { amenity: undefined, features: [], icon: Entertainment },
  };

  // Map amenities to their respective amenity titles
  for (const amenity of amenities) {
    if (amenityMapping[amenity.title]) {
      amenityMapping[amenity.title].amenity = amenity;
    }
  }

  // Map features to their respective amenities
  for (const feature of features) {
    for (const key in amenityMapping) {
      const { amenity } = amenityMapping[key];
      if (feature.properties?.amenity === amenity?.id) {
        amenityMapping[key].features.push(feature);
      }
    }
  }

  // Utility function to retrieve a translated title
  const getTranslatedTitle = (feature: Feature): string => {
    const { title_i18n, title } = feature.properties || {};
    return title_i18n?.[language] || title_i18n?.en || title;
  };

  const items: FilterItemModel[] = [];

  // Create filter items for each amenity based on available features
  for (const key in amenityMapping) {
    const { amenity, features, icon } = amenityMapping[key];

    if (amenity && features.length > 0) {
      let itemTitle: string | undefined;

      // If there is only one feature, use the feature title
      if (features.length === 1) {
        itemTitle = getTranslatedTitle(features[0]);
      }

      // Set up the item object for the filter list
      const baseItem: FilterItemModel = {
        title: key.toLowerCase().replace(/\s/g, "-"), // Convert title to kebab-case
        translatedTitle: itemTitle,
        iconImage: icon,
        id: [amenity.id],
        hideMapIcon: true,
        type: "list",
      };

      // Push items to the list based on the type (list or single)
      if (key === "Entertainment") {
        // For "Entertainment", push individual features
        features.forEach((feature) => {
          items.push({
            ...baseItem,
            type: "single",
            title: getTranslatedTitle(feature)
              .toLowerCase()
              .replace(/\s/g, "-"), // Convert title to kebab-case
            translatedTitle: getTranslatedTitle(feature),
            featureId: feature.id,
          });
        });
      } else {
        // For other amenities, push as a list
        items.push(baseItem);
      }
    }
  }

  const entertainmentIndex = filterCategories.findIndex(
    (category) => category.id === "leisure",
  );
  filterCategories[entertainmentIndex].items = items;
};
